/* eslint-disable camelcase,eqeqeq,no-param-reassign,no-useless-escape */

import { COMPONENT_TYPE } from '../../../../../app/constants/component_type';

xplenty.directive('databaseDefinition', [
  '$rootScope',
  function ($rootScope) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./database-definition.html'),

      replace: true,

      scope: false,

      link(scope, element, attrs) {
        scope.hasAccessMode = attrs.accessMode === 'true';
        scope.hasSchema = attrs.schema === 'true';
        scope.hasWhereClause = attrs.whereClause === 'true';
        scope.hasQuery = attrs.query === 'true';
        scope.hasCollection = attrs.collection === 'true';

        if (attrs.whereClauseType === 'json') {
          scope.whereClauseEditorOptions.mode = 'application/json';
          scope.whereClauseEditorOptions.placeholder = '{"age":{"$gt":24}}';
        } else {
          scope.whereClauseEditorOptions.placeholder = "prod_category = 1 AND prod_color = 'red'";
        }

        if (scope.hasAccessMode) {
          scope.$watch('component.access_mode', function (access_mode) {
            if (access_mode === 'table') {
              scope.hasTable = true;
              scope.hasSchema = attrs.schema === 'true';
              scope.hasWhereClause = attrs.whereClause === 'true';
              scope.hasQuery = false;

              $rootScope.access_mode_table = true;
            } else if (access_mode === 'query') {
              scope.hasTable = false;
              scope.hasSchema = false;
              scope.hasWhereClause = false;
              scope.hasQuery = true;

              $rootScope.access_mode_table = false;
            }
          });
        } else {
          // if database can't change accessMode, we assume the default accessMode is table
          $rootScope.access_mode_table = true;
        }

        scope.$on('$destroy', function () {
          delete $rootScope.access_mode_table;
        });
      },

      controller: [
        '$scope',
        function ($scope) {
          $scope.hasAccessMode = false;
          $scope.hasSchema = false;
          $scope.hasTable = true;
          $scope.hasWhereClause = false;
          $scope.hasQuery = false;
          $scope.hasCollection = false;

          if ($scope.component.componentType === COMPONENT_TYPE.BIG_QUERY_SOURCE_COMPONENT) {
            $scope.queryEditorOptions = {
              placeholder:
                '/* Legacy SQL */ \nSELECT * FROM [project-id:dataset.table] \nSELECT * FROM dataset.table \n/* Standard SQL */ \nSELECT * from `project-id.dataset.table` \nSELECT * from project-id.dataset.table',
            };
          } else {
            $scope.queryEditorOptions = {};
          }

          $scope.whereClauseEditorOptions = {
            placeholder: "prod_category = 1 AND prod_color = 'red'",
          };
        },
      ],
    };
  },
]);
